import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { getFormValues, isValid, reduxForm, reset, touch, focus } from 'redux-form';

import * as adminLib from 'libs/adminLib';

import { Image, Button, Label } from 'semantic-ui-react';

import { ReduxFormMaterialTextField } from 'components';

import classNames from 'classnames/bind';
import styles from './CtAdminLogin.css';
const cx = classNames.bind(styles);

class CtAdminFirstLogin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      errorMessage: {
        type: '',
        content: ''
      }
    };
  }

  // 관리자 계정 최초 수정
  onAdminInitSetting = async () => {
    if (!!this.state.isLoading) {
      return false;
    }
    this.setState({ isLoading: true });
    try {
      // 국제화 처리
      const { formatMessage } = this.props.intl;
      const { formAdminInitSetting, isValidFormAdminInitSetting } = this.props;

      if (isValidFormAdminInitSetting) {
        this.setState({ isClicked: true });

        if (formAdminInitSetting.userPasswd === formAdminInitSetting.userPasswdCheck) {
          const params = {
            userEmail: formAdminInitSetting.userEmail,
            userPasswd: formAdminInitSetting.userPasswd,
            userName: formAdminInitSetting.userName
          };

          const respObj = await adminLib.adminInitSetting(params);
          if (respObj && respObj.status && respObj.status === 200) {
            if (respObj.data && Array.isArray(respObj.data.list)) {
              // ID/Password 변경 성공
              this.setState({
                errorMessage: {
                  type: 'success',
                  content: (
                    <div>
                      <div className={cx('brand bold font-size-16')}>
                        {defineMessages(formatMessage({ id: 'CtFirstLogin_5', defaultMessage: '변경 완료!' }))}
                      </div>
                    </div>
                  )
                }
              });
            } else {
              if (Array.isArray(respObj.data.error)) {
                this.setState({
                  errorMessage: {
                    type: 'userEmail',
                    content: respObj.data.error[0].errInfo
                  }
                });
              } else {
                // 비밀번호 틀림
                this.setState({
                  errorMessage: {
                    type: 'userEmail',
                    content: defineMessages(
                      formatMessage({ id: 'CtFirstLogin_6', defaultMessage: '비밀번호가 틀렸습니다.' })
                    )
                  }
                });
              }
            }
          } else {
            // 응답 오류
          }
        } else {
          // 비밀번호와 비밀번호 체크 일치 안함
          this.setState({
            errorMessage: {
              type: 'userPasswd',
              content: defineMessages(
                formatMessage({ id: 'CtAdminChangePW_3', defaultMessage: '비밀번호가 일치하지 않습니다.' })
              )
            }
          });
        }
      } else {
        this.markFieldValidate('formAdminInitSetting');
      }

      this.setState({ isLoading: false });
    } catch (e) {
      console.log(e);
    }
  };

  // 로그인
  onMove = () => {
    return window.location.replace('/mudmanage');
  };

  // 취소
  onCancel = () => {
    return window.location.reload();
  };

  markFieldValidate = formName => {
    const { dispatch, formStore } = this.props;

    if (formStore && formStore.registeredFields) {
      for (const field in formStore.registeredFields) {
        if (formStore.registeredFields.hasOwnProperty(field)) {
          if (formStore.registeredFields[field].count > 0) {
            dispatch(focus(formName, field));
            dispatch(touch(formName, field));
          }
        }
      }
    }
  };

  handleKeyPress = e => {
    if (e.key.toLowerCase() === 'enter') {
      this.onAdminInitSetting();
    }
  };

  render() {
    const { formatMessage } = this.props.intl;

    return (
      <div className={cx('admin-first-edit-area first-login')}>
        <div className={cx('display-flex')}>
          <Image src="/img/logo/m_logo.png" />
          <div>
            <Label className={cx('admin-title')}>
              {defineMessages(formatMessage({ id: 'CtFirstLogin_3', defaultMessage: '관리자 계정 최초 등록' }))}
            </Label>
            <div className={cx('bold mt-5')}>
              {defineMessages(
                formatMessage({
                  id: 'CtFirstLogin_4',
                  defaultMessage: '최초 로그인시 ID와 비밀번호를 변경 할 수 있습니다.'
                })
              )}
            </div>
          </div>
        </div>
        {this.state.errorMessage.type === 'success' ? (
          <div className={cx('modify-confirm')}>{this.state.errorMessage.content}</div>
        ) : (
          <div>
            <span className={cx('materialTextField-title')}>ID</span>
            <div className={cx('wrap-input')}>
              <ReduxFormMaterialTextField
                className={cx('input-area')}
                label={'ID'}
                fullWidth
                validate={['required', 'rangeID', 'mailId']}
                name="userEmail"
                checkType={101}
                onKeyPress={this.handleKeyPress}
                error={this.state.errorMessage.type === 'userEmail' ? true : false}
                helperText={this.state.errorMessage.type === 'userEmail' && this.state.errorMessage.content}
              />
            </div>
            <span className={cx('materialTextField-title')}>
              {defineMessages(formatMessage({ id: 'CtFirstLogin_11', defaultMessage: '비밀번호' }))}
            </span>
            <div className={cx('wrap-input')}>
              <ReduxFormMaterialTextField
                className={cx('input-area')}
                type="password"
                label={defineMessages(formatMessage({ id: 'CtAdminLogin_3', defaultMessage: '비밀번호' }))}
                fullWidth
                validate={['required', 'gsPassword']}
                name="userPasswd"
                checkType={101}
                onKeyPress={this.handleKeyPress}
                error={this.state.errorMessage.type === 'userPasswd' ? true : false}
                helperText={this.state.errorMessage.type === 'userPasswd' && this.state.errorMessage.content}
              />
              <span className={cx('materialTextField-title')}>
                {defineMessages(formatMessage({ id: 'CtFirstLogin_12', defaultMessage: '비밀번호 확인' }))}
              </span>
              <ReduxFormMaterialTextField
                className={cx('input-area')}
                type="password"
                fullWidth
                validate={['required', 'gsPassword']}
                name="userPasswdCheck"
                checkType={101}
                onKeyPress={this.handleKeyPress}
                error={this.state.errorMessage.type === 'userPasswdCheck' ? true : false}
                helperText={this.state.errorMessage.type === 'userPasswdCheck' && this.state.errorMessage.content}
              />
              <span className={cx('materialTextField-title')}>
                {defineMessages(formatMessage({ id: 'CtFirstLogin_13', defaultMessage: '이름*' }))}
              </span>
              <ReduxFormMaterialTextField
                className={cx('input-area')}
                label={defineMessages(formatMessage({ id: 'ExamDetail_20', defaultMessage: '이름' }))}
                fullWidth
                validate={['userName']}
                name="userName"
                checkType={101}
                onKeyPress={this.handleKeyPress}
              />
            </div>
          </div>
        )}
        <div>
          {this.state.errorMessage.type === 'success' ? (
            <div className={cx('button-area')}>
              <Button className={cx('bt-change')} onClick={this.onMove}>
                {defineMessages(formatMessage({ id: 'CtAdminLogin_4', defaultMessage: '로그인' }))}
              </Button>
            </div>
          ) : (
            <div className={cx('button-area')}>
              <Button className={cx('bt-change')} loading={this.state.isLoading} onClick={this.onAdminInitSetting}>
                {defineMessages(formatMessage({ id: 'CtFirstLogin_1', defaultMessage: '변경' }))}
              </Button>
              <Button className={cx('bt-noChange')} loading={this.state.isLoading} onClick={this.onCancel}>
                {defineMessages(formatMessage({ id: 'CtFirstLogin_2', defaultMessage: '취소' }))}
              </Button>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  formAdminInitSetting: getFormValues('formAdminInitSetting')(state),
  isValidFormAdminInitSetting: isValid('formAdminInitSetting')(state),
  formStore: state.form['formAdminInitSetting']
});

export default connect(mapStateToProps)(
  reduxForm({
    form: 'formAdminInitSetting',
    enableReinitialize: true,
    destroyOnUnmount: false,
    touchOnChange: true // validation 안내를 적절한 시점에 보이기 위해 반드시 필요함
  })(injectIntl(CtAdminFirstLogin))
);



// WEBPACK FOOTER //
// ./src/script/containers/admin/CtAdminFirstLogin.js